import {AppConstant} from "../app.constant";

const NOTEBOOK_MEDIA_QUERY = `(max-width: ${AppConstant.NOTEBOOK_WIDTH - 1}px)`;

function getNotebookViewportMatches() {
    return typeof window !== 'undefined' && window.matchMedia(NOTEBOOK_MEDIA_QUERY).matches;
}

/**
 * Миксин отслеживания размера и его изменения окна
 */
export default {
    data() {
        return {
            innerWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
            // matchMedia надёжнее innerWidth при первом рендере (лендинг с defer)
            isNotebookViewport: getNotebookViewportMatches(),
        };
    },
    mounted() {
        this.notebookMediaQuery = window.matchMedia(NOTEBOOK_MEDIA_QUERY);
        this.onNotebookMediaQueryChange = (event) => {
            this.isNotebookViewport = event.matches;
        };
        this.notebookMediaQuery.addEventListener('change', this.onNotebookMediaQueryChange);
        this.isNotebookViewport = this.notebookMediaQuery.matches;

        this.onWindowResize();
        window.addEventListener('resize', this.onWindowResize);
    },
    beforeUnmount() {
        if (this.notebookMediaQuery && this.onNotebookMediaQueryChange) {
            this.notebookMediaQuery.removeEventListener('change', this.onNotebookMediaQueryChange);
        }
        window.removeEventListener('resize', this.onWindowResize);
    },
    methods: {
        onWindowResize() {
            this.innerWidth = window.innerWidth;
            if (this.notebookMediaQuery) {
                this.isNotebookViewport = this.notebookMediaQuery.matches;
            }
        },
    },
    computed: {
        // Ультраширики
        isUltraWide() {
            return this.innerWidth >= AppConstant.DESKTOP_WIDTH;
        },
        // Десктоп
        isDesktop() {
            return this.innerWidth < AppConstant.DESKTOP_WIDTH;
        },
        // Большие планшеты и ноутбуки
        isNotebook() {
            return this.isNotebookViewport;
        },
        // Планшеты и телефоны
        isTablet() {
            return this.innerWidth < AppConstant.TABLET_WIDTH;
        },
        // Маленькие телефоны
        isMobile() {
            return this.innerWidth < AppConstant.MOBILE_WIDTH;
        },
        getInnerWidth() {
            return this.innerWidth;
        },
    },
};
